import { hasAppRoute } from './routeLoaders';

export const APP_NAVIGATION_EVENT = 'chanhub:navigate';

export function navigateApp(target: string): void {
  const url = new URL(target, location.href);
  if (url.origin !== location.origin || !hasAppRoute(url.pathname)) { location.assign(url.href); return; }
  const next = `${url.pathname}${url.search}${url.hash}`;
  const current = `${location.pathname}${location.search}${location.hash}`;
  if (next !== current) history.pushState(null, '', next);
  window.dispatchEvent(new Event(APP_NAVIGATION_EVENT));
  window.scrollTo(0, 0);
}

export function handleAppLinkClick(event: MouseEvent): void {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('a[href]');
  if (!(link instanceof HTMLAnchorElement) || link.download || (link.target && link.target !== '_self')) return;
  const url = new URL(link.href, location.href);
  if (url.origin !== location.origin || !hasAppRoute(url.pathname)) return;
  if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
  event.preventDefault();
  navigateApp(url.href);
}
